import React, { useState } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';
import { parseGoogleJwt, handleGoogleAuthResponse } from '../services/googleAuthService';

const GoogleLoginButton = ({ className = '' }) => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const toast = useToast();
  const [loading, setLoading] = useState(false);

  const processSuccess = async (googleProfile) => {
    setLoading(true);
    try {
      const res = await handleGoogleAuthResponse(googleProfile, login);
      if (res.success) {
        toast.showSuccess(res.message || 'Successfully logged in with Google!');
        setTimeout(() => {
          navigate('/');
        }, 1200);
      } else {
        toast.showError(res.message || 'Google Sign-In failed.');
      }
    } catch (err) {
      console.error('Google Sign-In error:', err);
      toast.showError(err.message || 'An error occurred during Google Sign-In.');
    } finally {
      setLoading(false);
    }
  };

  const handleCredentialSuccess = async (credentialResponse) => {
    if (!credentialResponse?.credential) {
      toast.showError('Google authentication response was empty.');
      return;
    }
    const profile = parseGoogleJwt(credentialResponse.credential);
    if (!profile || !profile.email) {
      toast.showError('Failed to parse Google user profile.');
      return;
    }
    await processSuccess(profile);
  };

  const handleGoogleError = () => {
    toast.showError('Google Sign-In was cancelled or failed.');
  };

  return (
    <div className={`google-auth-container my-3 ${className}`} style={{ width: '100%' }}>
      <div className="d-flex align-items-center justify-content-center mb-3">
        <div style={{ flex: 1, height: '1px', backgroundColor: '#e2e8f0' }}></div>
        <span className="px-3 text-muted" style={{ fontSize: '14px', fontWeight: 500 }}>OR</span>
        <div style={{ flex: 1, height: '1px', backgroundColor: '#e2e8f0' }}></div>
      </div>

      <div className="google-login-btn-wrapper d-flex justify-content-center position-relative">
        {loading && (
          <div 
            className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
            style={{ backgroundColor: 'rgba(255,255,255,0.85)', zIndex: 10, borderRadius: '4px' }}
          >
            <div className="spinner-border spinner-border-sm text-primary me-2" role="status"></div>
            <span style={{ fontSize: '14px', fontWeight: 500, color: '#333' }}>Authenticating with Google...</span>
          </div>
        )}
        <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
          <GoogleLogin
            onSuccess={handleCredentialSuccess}
            onError={handleGoogleError}
            useOneTap={false}
            theme="outline"
            size="large"
            text="continue_with"
            shape="rectangular"
            width="320"
          />
        </div>
      </div>
    </div>
  );
};

export default GoogleLoginButton;
